import React, { useEffect, useContext, useState } from "react";
import apiClient from "../../../../api/Api.js";
import { DataContext } from "../../../../context/dataprovider.js";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Typography,
} from "@mui/material";

const FormsAnalysis = ({ fromDate, toDate, projectId }) => {
  const { userData = {}, loading } = useContext(DataContext);
  const Analysis_api = process.env.REACT_APP_ANALYTICS;

  const [tableData, setTableData] = useState([]);

  const fixedCols = [
    "Site Expenditure",
    "Material and PO Payment", // Only this normalized version will be used
    "UPI payment",
    "General",
  ];

  const getFormsAnaylsisData = async () => {
    try {
      const response = await apiClient.post(`${Analysis_api}/get_forms_table`, {
        projectId: projectId,
        fromDate: fromDate,
        toDate: toDate,
      });

      const rawData = response.data;

      const formatted = Object.entries(rawData).map(([project, types]) => {
        const row = { project };

        // Normalize keys to avoid inconsistencies
        const normalizedTypes = {};
        Object.entries(types).forEach(([key, value]) => {
          let normalizedKey = key.trim(); // remove extra spaces

          // Handle known key inconsistency
          if (normalizedKey === "Material and PO Payments") {
            normalizedKey = "Material and PO Payment";
          }

          if (!normalizedTypes[normalizedKey]) {
            normalizedTypes[normalizedKey] = 0;
          }

          normalizedTypes[normalizedKey] += value;
        });

        fixedCols.forEach((col) => {
          row[col] = normalizedTypes[col] || 0;
        });

        return row;
      });

      setTableData(formatted);
    } catch (error) {
      console.error("Error in Transaction Analysis:", error);
    }
  };

  useEffect(() => {
    if (!loading && projectId && projectId.length > 0) {
      getFormsAnaylsisData();
    }
  }, [loading, projectId, fromDate, toDate]);

  return (
    <div style={{ padding: "1rem" }}>
      <Typography variant="h6" gutterBottom>
        Forms Analysis
      </Typography>
      <TableContainer component={Paper} elevation={3}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Project</strong>
              </TableCell>
              {fixedCols.map((col) => (
                <TableCell key={col}>
                  <strong>{col}</strong>
                </TableCell>
              ))}
              <TableCell>
                <strong>Total PR's</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row) => (
              <TableRow key={row.project}>
                <TableCell>{row.project}</TableCell>
                {fixedCols.map((col) => (
                  <TableCell key={col}>{row[col]}</TableCell>
                ))}
                <TableCell>
                  {fixedCols.reduce((sum, col) => sum + (row[col] || 0), 0)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default FormsAnalysis;
